export * from './advanced-filters';
export * from './api-token';
export * from './api-responses';
export * from './audit';
export * from './calculation';
export * from './chat';
export * from './cohort';
export * from './curation';
export * from './dataset';
export * from './data-curation';
export * from './dataset';
export * from './deidentification';
export * from './filter';
export * from './mock-dataset-ids';
export * from './ontology';
export * from './ontology-builder';
export * from './patient';
export * from './data-curation-result';
export * from './document-extraction';
export * from './provenance';
export * from './querybot-kb';
export * from './stats';
export * from './registry-standards';
export * from './user';

export type NamePath = (string | number)[];
export interface ValidateErrorEntity<Values = any> {
    values: Values;
    errorFields: {
        name: NamePath;
        errors: string[];
    }[];
    outOfDate: boolean;
}
export function isValidateErrorEntity<Values = any>(error: any): error is ValidateErrorEntity<Values> {
    return error && 'values' in error && 'errorFields' in error && 'outOfDate' in error;
}
